import React from 'react'
import { ColumnParent, Column } from 'components/layout'
import AppContainer from './app-container'
import inlineStyles from 'styles/inline.css.js'
import './form.styl'
import Header from 'components/header/header'
import Input from 'components/input/input'
import Tooltip from 'components/tooltip/tooltip'
import styled, { css } from 'styled-components'

class Form extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      returnAndTaxCalc: 'Manual',
      input: this.props.input,
      error: this.props.error,
      aggregateTaxType: this.props.aggregateTaxType,
      saveSuccess: this.props.saveSuccess
    }

    this.handleDropdownChange = this.handleDropdownChange.bind(this)
  }

  componentWillReceiveProps(nextProps){
    if(this.props.input !== nextProps.input){
      this.setState({
        input: nextProps.input
      })
    }

    if(this.props.aggregateTaxType !== nextProps.aggregateTaxType){
      this.setState({
        aggregateTaxType: nextProps.aggregateTaxType
      })
    }

    if(this.props.saveSuccess != nextProps.saveSuccess){
      this.setState({
        saveSuccess: nextProps.saveSuccess
      })
    }

    if(this.props.error !== nextProps.error){
      this.setState({
        error: nextProps.error
      })
    }
  }
  handleDropdownChange(event){
    if(event.target.value === "Manual"){
      this.setState({
        returnAndTaxCalc: "Manual"
      })
    }else if(event.target.value == "Use calculator"){
      this.setState({
        returnAndTaxCalc: "Use calculator"
      })
    }else{
      this.props.changeGlobalState("agg_tax_type",event.target.value)
    }
  }

  render(){
    const returnAndTax = [
      {
        key: "portfolio_return_accu",
        value: "Manual",
      },
      {
        key: "",
        value: "Use calculator",
      }
    ]

    return(
      <RC_form>
        {
          this.state.error.hasError ? 
          <Notification error>
          {this.props.error.message}
          </Notification>
          : <div />
        }
        {
          this.state.saveSuccess ? 
          <Notification success>
            Save Successful.
          </Notification>
          : <div />
        }
        {
          this.props.forecast ?
          <FormContent>
            <Header>Target for Retirement</Header>
            <div className={this.props.forecast === "Retirement age" ? "hide" : "FormQuestion"}><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Target age of retirement"/></div><p>Age<Input type="text" changeGlobalState={this.props.changeGlobalState} name="retirement_age_target" value={this.state.input['retirement_age_target']} validation="age"/></p></div>
            <div className={this.props.forecast === "Annual income after retirement" ? "hide" : "FormQuestion"}><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Target annual distribution from portfolio after retirement in today's purchasing"/></div><p>Annual income after retirement<Input type="Number" changeGlobalState={this.props.changeGlobalState} name="annual_income" value={this.state.input['annual_income']}/></p></div>
            <div className={this.props.forecast === "After-tax savings per annum" ? "hide" : "FormQuestion"}><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Estimated starting amount of annual after-tax contributions to portfolio during employment"/></div><p>After-tax savings per annum (non-pension)<Input type="Number" changeGlobalState={this.props.changeGlobalState} name="contributions_at" value={this.state.input['contributions_at']}/></p></div>
          </FormContent>
          : <div />
        }
        {/* Asusumptions/Inputs */}
        <Header>Assumptions/Inputs</Header>
        <FormContent>
          <FormQuestion><p>Current age<Input type="text" changeGlobalState={this.props.changeGlobalState} name="current_age" value={this.state.input['current_age']} validation={"age"} hasError={this.props.error}/></p></FormQuestion>
          <FormQuestion><p>Life expectancy age<Input type="text" changeGlobalState={this.props.changeGlobalState} name="life_expectancy" value={this.state.input['life_expectancy']} validation={"age"}/></p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Average Expectation of annual rate of inflation"/></div><p>Inflation expectation per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="inflation" value={this.state.input['inflation']} validation={'percent'} hasError={this.state.error}/>%</p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Estimated annual portfolio return from today until retirement"/></div><p>Portfolio return in savings phase per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="portfolio_return_accu" value={this.state.input['portfolio_return_accu']} validation={'percent'} hasError={this.state.error}/>%</p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Estimated annual portfolio return after retirement. Likely to be lower than pre-retirement portfolio as capital preservation becomes more important than growth"/></div><p>Portfolio return in retirement per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="portfolio_return_dist" value={this.state.input['portfolio_return_dist']} validation={'percent'}/>%</p></FormQuestion>
        </FormContent>

        {/* Manual/Calculator
        <Header>Accumulation Stage</Header>
        <div className="FormContent">
          {/* REMOVE UNTIL CALCULATOR AVAILABLE - Default to manual
          {/*<div className="FormQuestion"><p>Return and tax calculation:<Tooltip tooltip="Calculation of your annual portfolio return and tax to be applied on your after-tax portfolio from now until the age you retire"/><Input type="dropdown" dropdownInfo={returnAndTax} onChange={this.handleDropdownChange} /></p></div>
          <div className="FormQuestion"><div className={this.state.returnAndTaxCalc == "Manual" ? "" : "hide"}><p>Portfolio return<Tooltip tooltip="Estimated annual portfolio return from now until you retire"/><Input type="text" changeGlobalState={this.props.changeGlobalState} name="portfolio_return_accu" value={this.state.input['portfolio_return_accu']} validation={'percent'}/>%</p></div></div>
        </div>*/}

        {/* Pension Savings (Pre-tax) */}
        <FormHeader><div className="TooltipIndicator TooltipIndicator--Header"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Investment portfolio accumulated from earnings that are not taxed until drawdown (e.g. pension account)"/></div><Header>Pension Savings (Pre-tax)</Header></FormHeader>
        <FormContent>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Total amount in your pension as of today"/></div><p>Total investable wealth today<Input type="Number" changeGlobalState={this.props.changeGlobalState} name="inv_wealth_pt" value={this.state.input['inv_wealth_pt']}/></p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Starting amount of future annual contributions to your pension account"/></div><p>Savings per annum<Input type="Number" changeGlobalState={this.props.changeGlobalState} name="pretax_contribution" value={this.state.input['pretax_contribution']}/></p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Estimated increase of annual contribution in your pension account"/></div><p>Increase in savings per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="cont_growth_pt" value={this.state.input['cont_growth_pt']} validation={'percent'}/>%</p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Tax on annual distributions from your pension account after retirement. Default rate: income tax"/></div><p>Tax on distribution<Input type="text" changeGlobalState={this.props.changeGlobalState} name="tax_dist_pt" value={this.state.input['tax_dist_pt']} validation={'percent'}/>%</p></FormQuestion>
        </FormContent>

        {/* Non-pension Savings (After-tax) */}
        <FormHeader><div className="TooltipIndicator TooltipIndicator--Header"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Investment portfolio comprising savings on which tax has been paid"/></div><Header>Non-pension Savings (After-tax)</Header></FormHeader>
        <FormContent>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Total amount in your portfolio as of today (This excludes your personal residence but includes Firm shares)"/></div><p>Investable wealth today<Input type="Number" changeGlobalState={this.props.changeGlobalState} name="inv_wealth_at" value={this.state.input['inv_wealth_at']}/></p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Estimated increase of annual after-tax contributions in your portfolio during saving phase
          "/></div><p>Increase in savings per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="cont_growth_at" value={this.state.input['cont_growth_at']} validation={'percent'}/>%</p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i><Tooltip tooltip="Annual: Pay tax annually regardless of when you realize your gains on your investments | Deferred: pay tax only when you sell your investments (ie. upon liquidation)"/></div><p>Tax treatment<Input type="dropdown" dropdownInfo={this.state.aggregateTaxType} value={this.state.input['agg_tax_type']} onChange={this.handleDropdownChange}/></p></FormQuestion>
          <FormQuestion><div className="TooltipIndicator"><i className="material-icons">&#xE88F;</i>{/*<div className={this.state.returnAndTaxCalc == "Manual" ? "" : "hide"}>*/}<Tooltip tooltip="Estimated blended tax rate on returns from your after-tax portfolio"/></div><p>Blended tax rate on portfolio return per annum<Input type="text" changeGlobalState={this.props.changeGlobalState} name="agg_tax" value={this.state.input['agg_tax']} validation={'percent'}/>%</p></FormQuestion>
        </FormContent>
      </RC_form>
    )
  }
}
export default AppContainer(Form)

const RC_form = styled.div`
  padding: 50px 20px 30px 20px;
`

const FormQuestion = styled.div`
  font-weight: 300;
  display: inline;
  position: relative;
`

const Hide = styled.div`
  display: none;
`

const Notification = styled.div`
  width: 100%;
  height: auto;
  padding: 10px 15px;

  ${props => props.success && css`
    background: #87dda5;
    color: #4e8260;
  `}

  ${props => props.error && css`
    background: #f27b7b;
    color: #913737;
  `}
`

const FormContent = styled.div`
  .TooltipIndicator:hover .Tooltip{
    visibility: visible;
    transform: translateX(0);
    opacity: 0.93;
  }

  p{
    display: flex;
    font-weight: 300;
    padding-left: 25px; 
  }
`

const FormHeader = styled.div`
  position: relative;

  .TooltipIndicator--Header:hover .Tooltip{
    visibility: visible;
    transform: translateX(0);
    opacity: 0.93;
    margin-top: 5px;
    margin-left: 1px;
  }
`

const TooltipIndicator = styled.div`
  i{
    position: absolute;
    font-size: 18px;
  }
  
  i:hover{
    cursor: help;
  }
  ${props => props.header && css`
    i{
      z-index: 1;
      padding-top: 3px;
      font-size: 20px;
    }
  `}
`


// WEBPACK FOOTER //
// ./components/form/form.js